<template>
  <div class="product-recommendations">
    <div class="product-recommendations__headline">
      <div class="product-recommendations__title">
        {{ title }}

        <span class="product-recommendations__count">
          {{ sliderData.length }}
        </span>
      </div>

      <div class="product-recommendations__navigation">
        <div
          ref="prevButton"
          class="swiper-button-prev product-recommendations__btn product-recommendations__btn--prev"
          slot="button-prev"
        />

        <div
          ref="nextButton"
          class="swiper-button-next product-recommendations__btn product-recommendations__btn--next"
          slot="button-next"
        />
      </div>
    </div>

    <swiper
      class="swiper"
      :class="{ 'swiper--has-after': shouldShowSwiperAfter }"
      :options="swiperOption"
      ref="swiper"
    >
      <swiper-slide
        class="swiper-item"
        v-for="item in computedProducts"
        :key="item.id"
      >
        <div class="item">
          <div
            class="item__headline"
          >
            <a
              :href="item.link"
              class="item__img"
            >
              <img
                :src="item.image_url"
                alt="product photo"
              >
            </a>

            <a
              :href="item.link"
              class="item__title"
            >
              {{ item.name}}
            </a>
          </div>

          <div class="item__info">
            <div class="item__price">
              <div
                class="item__price"
                :class="{'item__price--new': item.is_sale}"
              >
                {{ item.price_new | CurrencyFormatter }}
              </div>

              <div
                v-if="item.is_sale"
                class="item__price--old"
              >
                {{ item.price_old | CurrencyFormatter }}
              </div>
            </div>

            <BuyBtn
              :title-ru="item.name"
              :product-id="item.id"
              :code="item.code"
              :price="item.price_new"
              :product-link="item.link"
              :store-id="item.available_in_store && item.available_in_store.store_id ? item.available_in_store.store_id : ''"
              type="icon-only"
            />
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import BuyBtn from '@/components/cart/BuyBtn.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import CurrencyFormatter from '@/filters/CurrencyFormatter'

export default {
  name: 'ProductRecommendations',
  components: { SwiperSlide, BuyBtn, Swiper },
  data () {
    return {
      swiperOption: {
        spaceBetween: 10,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.product-recommendations__btn--next',
          prevEl: '.product-recommendations__btn--prev'
        }
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      required: true
    }
  },
  computed: {
    sliderData () {
      if (this.products.length) {
        return this.products
      }
      return []
    },
    computedProducts () {
      return this.products.map(item => {
        const priceNew = item.price_new ?? (item.price?.price_new != null ? Number(item.price.price_new) : null)
        const priceOld = item.price_old ?? (item.price?.price_old != null ? Number(item.price.price_old) : null)

        return {
          id: item.id,
          code: item.code,
          name: item.name || item.title,
          image_url: item.image_url || item.photos?.image_url || item.photos?.[0]?.thumb || '',
          price_new: priceNew,
          price_old: priceOld,
          is_sale: priceOld != null && priceNew != null && priceOld > priceNew && priceNew > 0,
          link: item.link,
          available_in_store: item.available_in_store || item.available_only_in_store_data
        }
      })
    },
    shouldShowSwiperAfter () {
      return this.computedProducts.length > 2
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style lang="sass" scoped>
  @import "~swiper/css/swiper.min.css"
  @import "../../../styles/swiper/swiper"

  a
    all: unset
    cursor: pointer

  .product-recommendations
    display: flex
    flex-direction: column
    gap: 10px
    margin-top: 35px

    border-radius: 3px
    padding: 15px 0 20px 20px
    background-color: #F8F8F8
    overflow: hidden
    +mmax($tablet)
      margin-top: 20px

    &__headline
      display: flex
      justify-content: space-between
      align-items: center

      padding-right: 13px

    &__title
      font-size: 16px
      font-weight: 500
      line-height: 16px
      letter-spacing: 0
      color: $text-color

    &__count
      color: $nd-label-color
      margin-left: 5px

    &__navigation
      display: none
      position: relative
      width: 70px
      height: 30px

      +mmin($tablet)
        display: block

    &__btn
      margin: 0
      top: 0

  .item
    display: flex
    flex-direction: column
    gap: 5px

    border: 1px solid #E7E7E7
    border-radius: 3px
    background-color: $page-bg

    width: 270px
    height: 125px
    padding: 10px
    box-sizing: border-box

    &__headline
      display: flex
      gap: 15px

    &__img
      position: relative

      flex-shrink: 0

      width: 55px
      height: 55px

      cursor: pointer

    &__title
      display: -webkit-box
      -webkit-box-orient: vertical
      -webkit-line-clamp: 3
      overflow: hidden
      max-height: 42px

      font-size: 14px
      line-height: 14px
      letter-spacing: 0
      color: $text-color

      cursor: pointer

    &__info
      display: flex
      align-items: center
      justify-content: space-between
      gap: 10px

    &__price
      display: flex
      align-items: center
      gap: 15px

      font-weight: 500
      font-size: 20px
      line-height: 20px
      letter-spacing: 0
      color: $text-color

      &--old
        font-weight: 400
        font-size: 14px
        line-height: 14px

        color: #909090
        text-decoration: line-through
        text-decoration-color: #FF2F00

      &--new
        color: #FF2F00

  .swiper
    position: relative
    z-index: 0
    max-width: 100%
    width: 100%

    &::after
      content: ''
      position: absolute
      top: 0
      bottom: 0
      right: 0
      z-index: 1

      display: none
      width: 27px
      background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 119.9%)
      pointer-events: none

      +mmin($tablet)
        width: 83px

    &--has-after
      &::after
        display: block

  .swiper-item
    width: 270px
</style>
